export default {
  title: 'Copay',
  description: 'A copay is a specific dollar amount that you’re required to pay for covered health care services or prescriptions, as defined by your insurance plan.',
  'is-paid': 'is paid',
}
